import styled from 'styled-components';

export const InitialState = styled.div`
  opacity: 0.5;
  font-size: 12px;
`;

export const Divider = styled.div`
  margin-top: 3px;
  margin-bottom: 3px;
  border-bottom: 1px solid #e0e0e0;
  height: 0px;
  width: 100%;
`;

export const BaseRunnerWrapper = styled.div`
  white-space: nowrap;
  width: 100%;
`;

export const FinalState = styled.div`
  font-size: 15px;
`;
